var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "technical-notes-section" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.technicalNotes.length > 0
                    ? _c("technical-notes-component", {
                        attrs: { content: _vm.technicalNotes },
                      })
                    : _c("h4", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n          There are no technical notes available for this product.\n        "
                        ),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }